import script from "./Enrich.vue?vue&type=script&setup=true&lang=js"
export * from "./Enrich.vue?vue&type=script&setup=true&lang=js"

import "./Enrich.vue?vue&type=style&index=0&id=1054865a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1054865a"]])

export default __exports__